module.exports = __webpack_public_path__ + "static/media/clicked-refer-and-earn.8b2c7884.svg";